import React, { useEffect } from "react";
import "./Latest_Videos.css";
import Common_Title_3 from "../../common/common_components/Common_Title_3/Common_Title_3";
import Latest_Card from "../../common/common_components/latest_card/Latest_Card";
import { useDispatch, useSelector } from "react-redux";
import { AllInsightVideo } from "../../../features/admin/common/Slice";

const Latest_Videos = () => {


  const dispatch = useDispatch();
  const insightVideo = useSelector((state) => state.common.all_insight_videos);

  useEffect(() => {
    dispatch(AllInsightVideo());
  }, [dispatch])
  return (
    <section className="Latest_Videos">
      <div className="container">
        <Common_Title_3 titleText="Latest Videos" seelink={'/all-latest-videos'} />

        <div className="row">
          {insightVideo?.slice(0, 4)?.map(
            ((video, index) => (
              <div className="col-xl-3 col-md-4 col-sm-6 mb-4" key={index}>
                <Latest_Card
                  mediaContent={
                    <iframe
                      className="media_content"
                      src={video?.link}
                      title={video?.name}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  }
                  name={video?.name}
                  description={video?.subname}
                />
              </div>
            ))
          )}
        </div>


        {/* <div className="row">
          {Array?.from({ length: 4 })?.map(
            ((_, index) => (
              <div className="col-xl-3 col-md-4 col-sm-6 mb-4" key={index}>
                <Latest_Card
                  mediaContent={
                    <iframe
                      className="media_content"
                      src="https://www.youtube.com/embed/1EZeY3IB1wk?list=PLKXRcYa-eMHpk454gGzeYr9FEAd4I1Q8z"
                      title="Dhyan Yogi Shri Narayan Swami #shorts"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  }
                />
              </div>
            ))
          )}
        </div> */}
      </div>
    </section>
  );
};

export default Latest_Videos;
